
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initSentry } from './utils/sentry'

// A page left open across deployments can reference an old lazy-loaded wallet
// chunk. Reload so Vite can resolve the current deployment's assets.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  window.location.reload()
})

sessionStorage.removeItem('asset-load-recovery')
const currentUrl = new URL(window.location.href)
if (currentUrl.searchParams.has('asset-reload')) {
  currentUrl.searchParams.delete('asset-reload')
  window.history.replaceState({}, '', currentUrl)
}

// Initialize Sentry
initSentry();

// Force correct page title
document.title = "Matic Moon";

createRoot(document.getElementById("root")!).render(<App />);
